export default __webpack_public_path__ + "static/media/sks-logo.87233a6b.png";